import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * TabItem component
 * Renders a navigation item button with a circular icon, label below, and optional status indicator.
 * @returns {JSX.Element} The rendered navigation item button.
 */
const TabItem = ({
  item,
  isCurrent,
  setCurrentItem,
  getStatusIcon,
  status,
  label,
  doctor,
  drImg,
}) => {

  const doctorImage = drImg || null;

  const handleClick = () => setCurrentItem(item.name);

  return (
    <button
      type="button"
      aria-pressed={isCurrent}
      onClick={handleClick}
      className={`horizontal-section-nav-button d-flex flex-column align-items-center ${
        item?.name !== "doctor_notes"
          ? "horizontal-section-nav-button--current"
          : ""
      }`}
    >
      {doctorImage !== null && (
        <img
          src={doctorImage}
          data-testid="status-icon"
          alt={label}
          style={{
            width: "133px",
            height: "133px",
            borderRadius: "50%",
            objectFit: "cover",
            marginBottom: "8px",
          }}
        />
      )}
      <div className={`horizontal-section-nav-button-label ${item?.name === "doctor_notes" && "doctor-details-section"}`}>
        Reviewed by{" "}
        <span className="horizontal-section-nav-button-title d-block">
          Dr {doctor}
        </span>
        {item.subtitle && (
          <span className="horizontal-section-nav-button-subtitle d-block">
            {item.subtitle}
          </span>
        )}
      </div>

      {item?.status && item?.area?.area_status && (
        <span
          className={`horizontal-section-nav-button-status horizontal-section-nav-button-status--${status}`}
          style={{ marginTop: "5px" }}
        >
          <FontAwesomeIcon icon={getStatusIcon(status)} />
        </span>
      )}
    </button>
  );
};

TabItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    background: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    status: PropTypes.string,
    area: PropTypes.object,
    area_status: PropTypes.string,
  }).isRequired,
  isCurrent: PropTypes.bool.isRequired,
  setCurrentItem: PropTypes.func.isRequired,
  getStatusIcon: PropTypes.func.isRequired,
  status: PropTypes.string,
  label: PropTypes.string,
  doctor: PropTypes.string,
  drImg: PropTypes.string, 
};

export default TabItem;
